var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgValidationErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2932 18.9005C22.9768 20.1003 22.1187 21.6 20.7533 21.6H2.97974C1.61172 21.6 0.757554 20.0979 1.43985 18.9005L10.3267 3.29945C11.0107 2.09909 12.7238 2.10128 13.4065 3.29945L22.2932 18.9005ZM10.36 7.76506L10.6234 14.359C10.6357 14.6675 10.8226 14.9091 11.0489 14.9091H12.7728C12.9992 14.9091 13.186 14.6675 13.1983 14.359L13.4617 7.76506C13.4751 7.43177 13.2807 7.15152 13.0363 7.15152H10.7854C10.541 7.15152 10.3467 7.43177 10.36 7.76506ZM11.9108 16.2667C11.054 16.2667 10.3593 16.968 10.3593 17.8331C10.3593 18.6982 11.054 19.3995 11.9108 19.3995C12.7677 19.3995 13.4624 18.6982 13.4624 17.8331C13.4624 16.968 12.7677 16.2667 11.9108 16.2667Z",
    fill: "#B4432F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationErrorRed);
export default __webpack_public_path__ + "static/media/validation-error-red.baae56f8.svg";
export { ForwardRef as ReactComponent };